import http from '@/services/http'
import data from '@/services/data'

export default {
  create (competitionId, payload) {
    return http.post(`/entry/${competitionId}`, payload)
  },
  async checkStatus (entryUuid) {
    let request
    try {
      request = await data.get(`/entry/status/${entryUuid}.json?t=${Date.now()}`)
    } catch (error) {
      // Fallback to API ignored by design
      request = Promise.resolve({ status: 'pending' })
    }
    return request
  }
}
